import classNames from 'classnames';
import { CategoryNode, CategoryNodes } from 'components/discover/publications/video-browser/model';
import { FC, Fragment, ReactNode } from 'react';

type CategoryListProps = Readonly<{
  activeCategory: CategoryNode | null;
  categories: CategoryNodes;
  onSelectCategory: (node: CategoryNode) => void;
  children: (category: CategoryNode) => ReactNode;
}>;

export const CategoryList: FC<CategoryListProps> = ({ activeCategory, categories, onSelectCategory, children }) => (
  <nav className="nav nav-vertical nav-underline nav-hover nav-lg px-2 d-none d-lg-block">
    {categories.map(cat => {
      const isActive = activeCategory?.id === cat.id;
      return (
        <Fragment key={cat.id}>
          <button
            type="button"
            className={classNames('nav-link text-truncate w-100 text-start', { active: isActive })}
            title={cat.name}
            onClick={() => onSelectCategory(cat)}
            role="menubar"
            name={cat.name}
          >
            {cat.name}
          </button>
          {children(cat)}
        </Fragment>
      );
    })}
  </nav>
);
